import React from 'react';
import PropTypes from 'prop-types';

const ControlledRadioButton = ({ checked = false, children, className = '', value, ...other }) => {
    const props = {
        className: 'spark-radio__input',
        checked: checked,
        value: value,
        type: 'radio'
    };
    return (
        <label className={`spark-radio ${className}`}>
            <input {...props} {...other} />
            <span className="spark-radio__box"></span>
            <span className="spark-label">{children}</span>
        </label>
    );
};

ControlledRadioButton.propTypes = {
    /** html attribute */
    checked: PropTypes.bool,
    /** HTML/RadioButton elements */
    children: PropTypes.node,
    /** Any extra CSS classes for the component */
    className: PropTypes.string,
    /** html attribute */
    value: PropTypes.string
};

ControlledRadioButton.displayName = 'RadioButton';

export default ControlledRadioButton;



// WEBPACK FOOTER //
// ./src/components/ui/sabre-spark-react-ex/radio/ControlledRadioButton.js